import React, { Component } from 'react';
import { Calendar, Badge, Modal, Card } from 'antd';
import styled from "styled-components";
import { db, auth } from '../config/fire';
import Loader from '../components/Loader';
import $ from 'jquery';

export const ModalContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
padding:15px;
.no-meet{
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.small-head{
    font-size: 14px;
    color: black;
    font-weight: 500;
}
.card-details{
    p{
        font-size:13px;
    }
}
`;

export const StartButton = styled.button`
outline: none;
border: none;
// background: rgb(0, 0, 0);
font-size: 14px;
color: white;
font-weight: 500;
padding: 5px 20px;
border-radius: 5px;
margin-top: 10px;
background-image: linear-gradient(to right,#41d4b3,#067D68);
`;

export const CalenderCell = styled.div`
.eve-logo{
    background-image: linear-gradient(to right,#41d4b3,#067D68);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0;
    width: 30px;
    height: 30px;
    font-size: 13px;
    font-weight: 800;
}
`;

export default class Scheduled extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: auth().currentUser,
            eventData: null,
            loading: true,
            visiblity: false,
            selectedDate: null,
            eventsCalender: [],
            tableViewData: [],
        }
    }

    componentDidMount(props) {
        console.log(window.location.href)
        const schdb = db().ref('users/' + this.state.user.uid + '/scheduled');

        // schdb.on('child_added', snapshot => {
        //     if(snapshot.exists()){
        //       const data = snapshot.val();
        //         this.setState({
        //             eventData: data,
        //             loading: false,
        //             error: '',
        //         });
        //     }
        //     else{
        //         this.setState({
        //             loading: false,
        //             eventData: null,
        //         })
        //     }

        // });
        let newEventArray = [];
        schdb.on('child_added', snapshot => {
            const data = snapshot.val();
            newEventArray.push(data);
            this.setState({
                error: '',
                eventData: data
            })

        });
        this.setState({
            eventsCalender: newEventArray,
            loading: false,
        })

    }


    formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }


    getListData = (value) => {
        let covertedDate = this.formatDate(value);
        let listData = [];
        if (this.state.eventsCalender.length > 0) {
            this.state.eventsCalender.forEach((currentEvent) => {
                if (currentEvent.date === covertedDate) {
                    listData.push({ type: 'success', content: `Time:${currentEvent.time}, meetingId: ${currentEvent.id}` })
                }
            })

        }
        return listData;
    }

    startMeetingFunc = () => {
        this.setState({
            loading: true,
        })
        const { eventData } = this.state;
        const sid = eventData.id;
        const sauth = eventData.auth;
        const sdate = eventData.date;
        const stime = eventData.time;
        const shost = eventData.host;
        const sallow = eventData.allow;
        const shname = eventData.hname;
        const pushdb = db().ref('all-rooms/' + sid);


        let susers;
        let spwd;
        if (sauth) {
            spwd = eventData.pass;
        }
        if (sallow) {
            susers = eventData.users;
        }
        if (sauth && sallow) {
            pushdb.set({
                'id': sid,
                'auth': sauth,
                'pass': spwd,
                'status': 'ACTIVE',
                'hname': shname,
                'users': susers,
                'host': shost,
            }).then(() => {
                window.location.replace('/room/' + sid);
            }).catch(err => {
                this.setState({
                    loading: false,
                    error: err.message,
                });
            })
        }
        else if (!sauth && !sallow) {
            pushdb.set({
                'id': sid,
                'auth': false,
                'hname': shname,
                'host': shost,
                'status': 'ACTIVE',
            }).then(() => {
                window.location.replace('/room/' + sid);
            }).catch(err => {
                this.setState({
                    loading: false,
                    error: err.message,
                });
            });
        }
        else if (sallow && !sauth) {
            pushdb.set({
                'id': sid,
                'hname': shname,
                'auth': false,
                'host': shost,
                'users': susers,
                'status': 'ACTIVE',
            }).then(() => {
                window.location.replace('/room/' + sid);
            }).catch(err => {
                this.setState({
                    loading: false,
                    error: err.message,
                });
            });

        }
        else if (sauth && !sallow) {
            pushdb.set({
                'id': sid,
                'auth': true,
                'pass': spwd,
                'hname': shname,
                'host': shost,
                'users': susers,
                'status': 'ACTIVE',
            }).then(() => {
                window.location.replace('/room/' + sid);
            }).catch(err => {
                this.setState({
                    loading: false,
                    error: err.message,
                });
            });

        }


    }

    dateCellRender = (value) => {
        const listData = this.getListData(value);
        return (
            <CalenderCell>
                {
                    listData && listData.length > 0 && <>
                        <p className='eve-logo'>{listData.length}</p>
                    </>
                }
            </CalenderCell>
        );
    }

    getMonthData = (value) => {
        if (value.month() === 8) {
            return 1394;
        }
    }

    monthCellRender = (value) => {
        const num = this.getMonthData(value);
        return num ? (
            <div className="notes-month">
                <section>{num}</section>
                <span>Backlog number</span>
            </div>
        ) : null;
    }

    onSelect = value => {
        let covertedDate = this.formatDate(value);
        let selected = [];
        if (this.state.eventsCalender.length > 0) {
            this.state.eventsCalender.map((currentEvent) => {
                console.log(currentEvent.date, covertedDate, 'currentEvent');
                if (currentEvent.date === covertedDate) {
                    console.log(currentEvent, 'currentEventcurrentEvent')
                    selected.push(currentEvent);
                }
            });
        }
        this.setState({
            visiblity: true,
            selectedDate: value,
            tableViewData: selected
        });
    };

    render() {
        console.log(this.state.tableViewData, 'event');

        return (
            <>
                {
                    this.state.loading ? <Loader /> :
                        <>
                            <div>
                                <Calendar onSelect={this.onSelect} dateCellRender={this.dateCellRender} monthCellRender={this.monthCellRender} />
                            </div>
                            <Modal
                                width={460}
                                centered
                                visible={this.state.visiblity}
                                onCancel={() => this.setState({ visiblity: false })}
                                footer={null}>
                                <ModalContainer style={{ flexDirection: 'column' }}>
                                    {
                                        this.state.tableViewData.length > 0 &&
                                        this.state.tableViewData.map((currentEvent) => {
                                            return (
                                                <Card className='card-details'>
                                                    <div>
                                                        <p>
                                                            <span className='small-head'> Date : </span>{currentEvent.date}<span className='small-head' style={{ paddingLeft: '20px' }}>Time :</span>{currentEvent.time}
                                                        </p>
                                                        <p> <span className='small-head'>Host : </span>{currentEvent.host}</p>
                                                        <div>
                                                            <p><span className='small-head'>Meeting Id :</span> {currentEvent.id}</p>
                                                            <StartButton onClick={() => this.startMeetingFunc()}>Start Meeting</StartButton>
                                                        </div>
                                                    </div>
                                                </Card>
                                            )
                                        })

                                    }
                                    {
                                        this.state.tableViewData.length === 0 && <p className='no-meet'>Today you don't have any meetings</p>
                                    }
                                </ModalContainer>
                            </Modal>
                            <div>{this.state.error}</div>

                        </>
                }
            </>
        );
    }
}
